import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SapOrdersService {
  constructor(private http:HttpClient) { }

  getSaleOrder(id: any, bd:string) : Promise<any> {
    return this.http.get('/api/sap/getSo', {params: {'order': id, 'dbName': bd}}).toPromise();
  }
  getPurchaseOrder(id: any, bd:string) : Promise<any> {
    return this.http.get('/api/sap/getPo', {params: {'order': id, 'dbName': bd}}).toPromise();
  }
}
